import {
  GET_CALLBACKS,
  GET_CALLBACKS_SUCCESS,
  GET_CALLBACKS_ERROR,
} from "./actionTypes";

export const getCallbacks = (user) => {
  return {
    type: GET_CALLBACKS,
    payload: { user },
  };
};

export const getCallbacksSuccess = (pendingCallbacks, message) => {
  return {
    type: GET_CALLBACKS_SUCCESS,
    payload: { pendingCallbacks, message },
  };
};

export const getCallbacksError = (msg) => {
  return {
    type: GET_CALLBACKS_ERROR,
    payload: msg,
  };
};
